export enum ClientType {
  Company = 'sxapp.company',
  Brf = 'sxapp.brf',
  Manager = 'sxapp.manager',
  Private = 'sxapp.private'
}
